import Cookies from "js-cookie";

export default class {
  constructor() {
    this.$textSize = $(".js-text-size-box");
    this.$colorBox = $(".js-color-box");
    this.textCookie = "wp-text-size";
    this.colorCookie = "wp-theme";
  }

  init() {
    const color = Cookies.get(this.colorCookie);
    if (Cookies.get(this.textCookie)) {
      this.setTextSize(Cookies.get(this.textCookie));
    }
    if (color === "gray" || color === "dark") {
      this.setColor(Cookies.get(this.colorCookie));
    }
    const self = this;

    this.$textSize.click(function click(e) {
      e.preventDefault();
      self.setTextSize($(this).data("size"));
    });

    this.$colorBox.click(function click(e) {
      e.preventDefault();
      self.setColor($(this).data("color"));
    });
  }

  setTextSize(textSize) {
    this.$textSize.removeClass("active");
    $("html")
      .removeClass("text-small text-large text-medium")
      .addClass(`text-${textSize}`);
    const $active = this.$textSize.filter(function filter() {
      return $(this).data("size") === textSize;
    });
    $active.addClass("active");
    Cookies.set(this.textCookie, textSize, { expires: 7 });
  }

  setColor(color) {
    this.$colorBox.removeClass("active");

    $(document.body).removeClass(
      "theme_white theme_gray theme_black theme_blue theme_orange theme_dark",
    );
    $(document.body).addClass(`theme_${color}`);

    const $active = this.$colorBox.filter(function filter() {
      return $(this).data("color") === color;
    });
    $active.addClass("active");
    Cookies.set(this.colorCookie, color, { expires: 7 });
  }
}
